import { FaChevronDown } from "react-icons/fa6"

import { Spinner } from "../../Spinner/Spinner"
import { SelectableOption } from "../../Shared/Shared"


interface Props {
    onClick?():void
    options?: SelectableOption[]
    value?: any
    placeholder?: string
    disableEditing?: boolean
    isLoading?:boolean
}
export function DropdownHeader(props: Props) {
    const { options, value, onClick, placeholder, disableEditing,isLoading } = props;
    let content;
    if (!options) {
        content = <div style={{ textAlign: "center", width: "100%" }}><Spinner /></div>
    } else if (value) {
        const option = options.find(option => option.value === value);
        content = option ? <span>{option.label}</span> : <span className="warning">"Not found"</span>;
    } else {
        content = disableEditing ? <span >{placeholder || "Not set"}</span> : <span >{placeholder || "Select..."}</span>;
    }

    if (isLoading) {
        if (disableEditing) {
            return <div className="DropwdownHeader">
                <button >
                    <div className="flex" >
                    <Spinner />
                    </div>
                </button>
            </div>
        }
    }

    if (disableEditing) {
        return <div className="DropwdownHeader">
            <button >
                {content}
            </button>
        </div>
    }

    return <div className="DropwdownHeader">
        <button onClick={onClick}>
            {content}
            <div className="chevron" ><FaChevronDown /></div>
        </button>
    </div>
}

